import SocialBox, { SocialBoxProps } from './SocialBox'

export default SocialBox

export { type SocialBoxProps, SocialBox }
